import React from 'react';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { useIntl } from 'react-intl';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import moment from 'moment';
import PropTypes from 'prop-types';
import MomentUtils from '@date-io/moment';
import { SIMPLE_DATE_FORMAT } from '../../utils/utils';

export const DatePicker = props => {
  const { locale } = useIntl();

  return (
    <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale={locale}>
      <KeyboardDatePicker
        disableToolbar
        variant="inline"
        id="date-picker-inline"
        InputLabelProps={{ shrink: true }}
        keyboardIcon={<CalendarTodayIcon />}
        format={SIMPLE_DATE_FORMAT}
        emptyLabel={SIMPLE_DATE_FORMAT}
        KeyboardButtonProps={{
          'aria-label': 'change date'
        }}
        {...props}
      />
    </MuiPickersUtilsProvider>
  );
};

DatePicker.propTypes = {
  label: PropTypes.object,
  value: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool
};
